import "./Footer.css";

function Footer() {
  return (
    <footer>
      <div class="container">
        <p>&copy; 2023 Omar Elsaid. All rights reserved.</p>
        <ul>
          <li>
            <a href="https://www.facebook.com/omar7275">
              <i class="fab fa-facebook"></i>
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/omar-elsaid-23612018a/">
              <i class="fab fa-linkedin"></i>
            </a>
          </li>
          <li>
            <a href="https://github.com/omarelsaid20">
              <i class="fab fa-github"></i>
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
